function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".disableManagement_svg__b{fill:#cc5e5e}.disableManagement_svg__c{fill:#e27d7d}.disableManagement_svg__e{opacity:.13}.disableManagement_svg__f{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 39,
  fill: "#ff8787"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "disableManagement_svg__b",
  d: "M42.999 72.052a1.594 1.594 0 001.376 1.79h.222a1.597 1.597 0 001.599-1.406l3.896-28.258-2.305-6.87z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "disableManagement_svg__c",
  d: "M45.835 28.278l-6.04 43.774a1.594 1.594 0 001.375 1.79h.223a1.597 1.597 0 001.598-1.406l5.15-37.288zM34.999 73.827a2.17 2.17 0 01-.223-.016 1.6 1.6 0 01-1.368-1.798L39.81 25.62a1.584 1.584 0 011.752-1.376c.015 0 .03.008.046.008a1.605 1.605 0 011.368 1.798l-6.402 46.394A1.585 1.585 0 0135 73.827z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "disableManagement_svg__b",
  d: "M31.802 73.827a2.17 2.17 0 01-.223-.016 1.6 1.6 0 01-1.368-1.798l6.402-46.402a1.584 1.584 0 011.752-1.376c.015 0 .03.008.046.008a1.605 1.605 0 011.368 1.798l-6.394 46.402a1.599 1.599 0 01-1.583 1.384z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.605 73.827a2.17 2.17 0 01-.223-.016 1.6 1.6 0 01-1.368-1.798l6.402-46.394a1.584 1.584 0 011.752-1.376c.015 0 .03.008.046.008a1.605 1.605 0 011.368 1.798L30.18 72.443a1.591 1.591 0 01-1.575 1.384z",
  fill: "#c44545"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "disableManagement_svg__e",
  d: "M45.224 32.824l4.564 13.658-.447 3.059-4.635-13.282.518-3.435z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "disableManagement_svg__e",
  d: "M46.188 35.875l-.467 2.669-5.94 34.019 5.438-39.532"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "disableManagement_svg__f",
  d: "M38.203 73.827a2.17 2.17 0 01-.222-.016 1.6 1.6 0 01-1.368-1.798l6.401-46.394a1.584 1.584 0 011.752-1.376c.016 0 .031.008.047.008a1.605 1.605 0 011.368 1.798l-6.402 46.394a1.591 1.591 0 01-1.576 1.384z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "disableManagement_svg__f",
  d: "M66.584 25.642a1.777 1.777 0 00-1.529-1.484 1.682 1.682 0 00-1.706 1.453l-8.046 27.566-9.2-27.875a1.489 1.489 0 01.031.522l-.99 6.857 8.737 26.367a1.597 1.597 0 003.051-.053l7.5-25.622 5.38 38.994a1.599 1.599 0 001.583 1.383 2.17 2.17 0 00.223-.015 1.605 1.605 0 001.368-1.799z"
});

var _ref11 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  className: "disableManagement_svg__f",
  d: "M93.924 74.97A7.704 7.704 0 0081.7 67.056a15.602 15.602 0 00-21.94-1.724 15.788 15.788 0 00-5.485 11.753v.079a3.815 3.815 0 00-.94-.079 7.757 7.757 0 000 15.515h34.947a9.715 9.715 0 009.716-9.713v-.082a10.024 10.024 0 00-4.074-7.835z"
}), React.createElement("path", {
  d: "M88.282 87.585H53.256a7.846 7.846 0 01-7.365-5.25 6.732 6.732 0 00-.392 2.508 7.759 7.759 0 007.679 7.757h35.104a9.715 9.715 0 009.716-9.713v-.003a8.804 8.804 0 00-.313-2.508 9.804 9.804 0 01-9.403 7.21z",
  fill: "#e8f4fa"
}), React.createElement("path", {
  d: "M93.924 74.97A7.704 7.704 0 0081.7 67.056a15.602 15.602 0 00-21.94-1.724 15.788 15.788 0 00-5.485 11.753v.079a3.815 3.815 0 00-.94-.079 7.757 7.757 0 000 15.515h34.947a9.715 9.715 0 009.716-9.713v-.082a10.024 10.024 0 00-4.074-7.835z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  stroke: "#191816"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M79.145 73.212A9.99 9.99 0 1081 79a10.04 10.04 0 00-1.855-5.788zM64.333 79a6.657 6.657 0 0110.048-5.738l-9.12 9.12A6.626 6.626 0 0164.334 79zM71 85.667a6.626 6.626 0 01-3.381-.929l9.12-9.12A6.657 6.657 0 0171 85.668z",
  fill: "#ff6242",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDisableManagement(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

export default __webpack_public_path__ + "disableManagement.58845.svg";
export { SvgDisableManagement as ReactComponent };